import { render, staticRenderFns } from "./Bed.vue?vue&type=template&id=defdcc48"
import script from "./Bed.vue?vue&type=script&lang=js"
export * from "./Bed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports